import { Divider, Row } from "antd";
import { BackToButton } from "components/Shared/BackToButton";
import { PageTitle } from "components/Shared/PageTitle";
import { useFetchEntity, useUpdateEntity } from "hooks/useEntitiesApi";
import { useFetchEntityGroups } from "hooks/useEntityGroupsApi";
import { useFetchVenues } from "hooks/useVenuesApi";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { EntityEditForm } from "./components/EntityEditForm";

export const EntityEditPage = () => {
  const { customerId, sport, organizationId, entityId: entityIdFromParams } = useParams();
  const entityId = entityIdFromParams || "undefined";
  const { formatMessage } = useIntl();
  const { data: entityResponse, isLoading: isEntityLoading } = useFetchEntity({
    entityId,
  });
  const entity = entityResponse?.data?.[0];
  const { data: venuesResponse, isLoading: isVenuesLoading } = useFetchVenues();
  const venues = venuesResponse?.data || [];
  const { data: entityGroupsResponse, isLoading: isEntityGroupsLoading } = useFetchEntityGroups();
  const entityGroups = entityGroupsResponse?.data || [];
  const { isPending: isEntityUpdating, mutate: updateEntity } = useUpdateEntity();

  const onEntitySave = (data: any) => {
    // Convert colors to HEX
    for (const key in data.colors) {
      if (data.colors[key] && typeof data.colors[key] !== "string") {
        data.colors[key] = data.colors[key].toHex();
      }
    }
    updateEntity({ entityId, data });
  };

  return (
    <>
      <Row className="mt-15" justify="space-between">
        <PageTitle
          isLoading={isEntityLoading}
          title={formatMessage({ id: "entityEditPage.title" }, { entityName: entity?.nameFullLocal })}
        />
        <BackToButton
          to={`/${customerId}/${sport}/${organizationId}/entities/${entityId}`}
          btnText={formatMessage({ id: "back.to.entity" })}
        />
      </Row>
      <Divider />
      <Row>
        <EntityEditForm
          isLoading={isEntityLoading || isVenuesLoading || isEntityGroupsLoading}
          isUpdating={isEntityUpdating}
          entity={entity}
          venues={venues}
          entityGroups={entityGroups}
          onSave={onEntitySave}
        />
      </Row>
    </>
  );
};
